import React from 'react';
import { createRoot } from 'react-dom/client';
import reportWebVitals from './reportWebVitals';

import '@total-typescript/ts-reset';
import '@/lib/i18n';
import '@/lib/utils/sentry';

import App from './app';
import './index.css';

const container = document.getElementById('root') as HTMLElement
createRoot(container).render(<App />);

reportWebVitals();
